import { Component, Element, h, Host, Prop, State, Listen } from '@stencil/core';

@Component({
  tag: 'bam-search-results',
  styleUrl: 'bam-search-results.scss',
})
export class BamSearchResults {
  @State() searchText: string;
  @Element() host: HTMLElement;
  @Prop() formName: string;
  @Prop() method: string;
  @Prop() action: string;
  @Prop() placeholder: string;
  @Prop() searchBtnText: string;
  @Prop() autoSuggestUrl: string;
  @Prop() queryParamName: string;
  @Prop() queryParamValue: string;
  form!: HTMLFormElement;

  handleSubmit = event => {
    event.preventDefault();
    setTimeout(() => {
      this.form.submit();
    }, 100);
  };

  @Listen('bamTypeahead')
  onBamTypeahead(event) {
    this.handleSubmit(event);
  }

  render() {
    const { formName, method, action, placeholder, queryParamName, queryParamValue, searchBtnText, autoSuggestUrl } = this;
    return (
      <Host>
        <form ref={el => (this.form = el as HTMLFormElement)} onSubmit={this.handleSubmit} name={formName} method={method} action={action} novalidate>
          <bal-field>
            <bal-field-control expanded-on-mobile>
              {formName === 'search-overlay-form' ? (
                <bal-input name={queryParamName} placeholder={placeholder} value={queryParamValue}></bal-input>
              ) : (
                <bam-typeahead ajax-url={autoSuggestUrl} name={queryParamName} placeholder={placeholder} value={queryParamValue}></bam-typeahead>
              )}
              <bal-button color="primary" elementType="submit" onClick={e => window.track(e)}>
                {searchBtnText}
              </bal-button>
            </bal-field-control>
          </bal-field>
          <slot></slot>
        </form>
      </Host>
    );
  }
}
